import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
// Admin Pages
import AdminDashboard from "./pages/admin/Dashboard";
import AdminRooms from "./pages/admin/Rooms";
import AdminTimeBlocks from "./pages/admin/TimeBlocks";
import AdminClients from "./pages/admin/Clients";
import AdminReservations from "./pages/admin/Reservations";
import AdminNonWorkingDays from "./pages/admin/NonWorkingDays";
import AdminCalendar from "./pages/admin/Calendar";
import AdminReembolsos from "./pages/admin/Reembolsos";
import AdminCreditos from "./pages/admin/Creditos";
import AdminSettings from "./pages/admin/Settings";

// Client Pages
import ClientDashboard from "./pages/client/Dashboard";
import ClientCalendar from "./pages/client/Calendar";
import ClientProfile from "./pages/client/Profile";
import ClientCreditos from "./pages/client/Creditos";
import ClientReservations from "./pages/client/Reservations";



const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/login" element={<Login />} />
            
            {/* Admin Routes - Protegidas */}
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute requiredRole="ADMIN">
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/rooms" 
              element={
                <ProtectedRoute requiredRole="ADMIN">
                  <AdminRooms />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/time-blocks" 
              element={
                <ProtectedRoute requiredRole="ADMIN">
                  <AdminTimeBlocks />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/non-working-days" 
              element={
                <ProtectedRoute requiredRole="ADMIN">
                  <AdminNonWorkingDays />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/clients" 
              element={
                <ProtectedRoute requiredRole="ADMIN">
                  <AdminClients />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/reservations" 
              element={
                <ProtectedRoute requiredRole="ADMIN">
                  <AdminReservations />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/calendar" 
              element={
                <ProtectedRoute requiredRole="ADMIN">
                  <AdminCalendar />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/reembolsos" 
              element={
                <ProtectedRoute requiredRole="ADMIN">
                  <AdminReembolsos />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/creditos" 
              element={
                <ProtectedRoute requiredRole="ADMIN">
                  <AdminCreditos />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/settings" 
              element={
                <ProtectedRoute requiredRole="ADMIN">
                  <AdminSettings />
                </ProtectedRoute>
              } 
            />
            
            {/* Client Routes - Protegidas */}
            <Route 
              path="/client" 
              element={
                <ProtectedRoute requiredRole="CLIENT">
                  <Navigate to="/client/calendar" replace />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/client/calendar" 
              element={
                <ProtectedRoute requiredRole="CLIENT">
                  <ClientCalendar />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/client/reservations" 
              element={
                <ProtectedRoute requiredRole="CLIENT">
                  <ClientReservations />
                </ProtectedRoute>
              } 
            />

            <Route 
              path="/client/profile" 
              element={
                <ProtectedRoute requiredRole="CLIENT">
                  <ClientProfile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/client/creditos" 
              element={
                <ProtectedRoute requiredRole="CLIENT">
                  <ClientCreditos />
                </ProtectedRoute>
              } 
            />

            
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
